window.$ = window.jQuery;

if ($('.js-customer-opinion-page').length > 0) {
    $('.js-customer-opinion-page').on('change',function(){
        window.location.href = $(this).val();
    });
}
